var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgProgress1 = function SvgProgress1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    fill: "none",
    viewBox: "0 0 58 58"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DCDCDC",
    d: "M36.845 52.386c.308.967 1.344 1.507 2.287 1.134a26.697 26.697 0 1 0-19.586.028c.944.37 1.978-.172 2.283-1.14.305-.967-.236-1.992-1.176-2.373a23.024 23.024 0 1 1 17.361-.025c-.939.384-1.477 1.41-1.169 2.376Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.734 26.057c-1.091-.118-2.079.672-2.114 1.769A26.697 26.697 0 0 0 18.817 53.25c1.01.43 2.142-.13 2.497-1.169.355-1.038-.204-2.16-1.207-2.604A22.723 22.723 0 0 1 6.584 28.251c.021-1.097-.76-2.077-1.85-2.194Z"
  })));
};
export default SvgProgress1;